import { render, staticRenderFns } from "./BitisFirmEdit.vue?vue&type=template&id=1718b21e&"
import script from "./BitisFirmEdit.vue?vue&type=script&lang=js&"
export * from "./BitisFirmEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports